module.exports = __webpack_public_path__ + "img/logotype-login.9014ba84.png";